import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import propertiesSectionData from "../data/propertiesSectionData";

export default function PropertiesPlaces() {
  const { t } = useTranslation();
  const location = useLocation();

  const urlParts = location.pathname.split("/").filter(Boolean);
  const lastUrlPart = urlParts[urlParts.length - 1];

  const filteredData = propertiesSectionData.filter(
    (item) => item.countries.toLowerCase() === lastUrlPart.toLowerCase()
  );

  const showData = filteredData.map((el, index) => {
    return (
      <div  key={index} className="w-100 w-[31%] h-[500px] rounded-[8px] shadow-md">
        <Link to={`/landDetailes/${el.id}`} className="w-full h-[250px]">
          <img
            src={el.mainImage}
            alt={el.title}
            className="w-full h-[250px] rounded-t-[8px]"
          />
        </Link>
        <div className="p-[15px] h-[50%] flex flex-col justify-between gap-[10px]">
          <div className="h-full flex flex-col gap-[15px] justify-between">
            <div className="flex flex-col gap-[4px]">
              <div className="font-bold text-[#0B2C3D]">{t(`${el.price}`)}</div>
              <div className="font-bold text-[17px]">{t(`${el.title}`)}</div>
              <div className="flex items-center gap-[5px]">
                <img className="w-[15px] h-[15px]" src={require("../../assets/icons/prop-location.svg").default} alt="" />
                <div>{t(`${el.countries}`)}, {t(`${el.city}`)}</div>
              </div>
            </div>
            <div className="flex items-center gap-[10px]">
              <div className="flex items-center gap-[5px]">
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/bed.svg").default} alt="" />
                <div>{t(`${el.bedroom}`)}</div>
              </div>
              |
              <div className="flex items-center gap-[5px]">
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/sqft.svg").default} alt="" />
                <div>{t(`${el.area}`)}</div>
              </div>
            </div>
            <div className="flex items-center justify-between gap-[7px]">
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"tel:+966 57 099 9395"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/phone-prop.svg").default} alt="" />
                <div>{t("Call")}</div>
              </Link>
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"mailto:info@ligasos.com"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/email-prop.svg").default} alt="" />
                <div>{t("Emails")}</div>
              </Link>
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"https://wa.link/544zck"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/whaats-prop.svg").default} alt="" />
                <div>{t("Whatsapp")}</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <>
      <section className="privacy-landing">
        <div className="container relative h-full flex flex-col items-center justify-center">
          <div className="">
            <div className="font-bold text-white text-[40px] capitalize">
              {t("Properties Places")}
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-wrap gap-[20px]">
          {showData.length > 0 ? (
            showData
          ) : (
            <div className="text-center w-full text-red-500">
              {t("No properties found for the selected country.")}
            </div>
          )}
        </div>
      </section>
    </>
  );
}